<script>
    import Image from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Image.svelte?1733898724762';
    import Dialog from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Dialog.svelte?1733898724762';

    export let open = false;
    export let id = 'image-dialog';
    export let images = [];
    export let index = 0;

    $: internal_images = cleanImages(images);
    $: amount = internal_images.length;
    $: src = internal_images[index]?.src;
    $: label = internal_images[index]?.label;

    function onKeyDown(event) {
        if (event.key === 'ArrowLeft') {
            return prevImage();
        }
        if (event.key === 'ArrowRight') {
            return nextImage();
        }
    }

    function nextImage() {
        index = (index + 1) % internal_images.length;
    }
    function prevImage() {
        index = (index - 1 + internal_images.length) % internal_images.length;
    }
    function cleanImages(list) {
        return list.filter((i) => i && i.src);
    }
</script>

<Dialog {id} bind:open scroll={false} {onKeyDown} cssClass="c-image-dialog">
    <slot slot="close" name="close" />
    <div class="c-image-dialog-content">
        {#if amount > 1}
            <button class="image-button-overlay__left prev" on:click={prevImage}>
                <i class="ri-arrow-left-s-line"></i>
            </button>
        {/if}
        <Image {src} alt={label} width={1200} />
        {#if amount > 1}
            <button class="image-button-overlay__right next" on:click={nextImage}>
                <i class="ri-arrow-right-s-line"></i>
            </button>
        {/if}
        {#if label}
            <div class="label">{label}</div>
        {/if}
        {#if amount > 1}
            <div class="number">{window.__('paging.x_of_y', { x: index + 1, y: amount })}</div>
        {/if}
    </div>
</Dialog>


<style>
    

    :global(.c-image-dialog .dialog) {
        padding: 1rem;
    }

    :global(.m-product-media-gallery .c-dialog-wrapper .dialog .content) {
        position: relative;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0;
    }

    :global(.m-product-media-gallery .c-dialog-wrapper header.dialog-header) {
        position: absolute;
        right: 1rem;
        top: 1rem;
        justify-content: flex-end;
        border-bottom: none;
        padding: 0;
        z-index: 100;
    }

    .image-button-overlay__left,
    .image-button-overlay__right {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        bottom: 0;
        text-shadow: 0 0 var(--space) rgba(0,0,0,.3);
        font-size: var(--space-x3);
        height: 100%;
        border: none;
        padding-left: 0;
        padding-right: 0;

        @media (hover: hover) {
            color: var(--color-text-invert);
            transition: opacity .5s linear;
            cursor: pointer;
            opacity: 0;
        }
    }

    .image-button-overlay__left:hover,
    .image-button-overlay__right:hover {
        opacity: 1;
    }

    .image-button-overlay__left {
        justify-content: flex-start;
        left: 0;
        right: 50%;
    }

    .image-button-overlay__right {
        justify-content: flex-end;
        left: 50%;
        right: 0;
    }

    .c-image-dialog-content :global(img) {
        max-height: 80vh;
        max-width: 100%;
        object-fit: contain;
        width: auto;
    }

    .label {
        text-align: center;
        padding-top: 0.25rem;
        font-size: 0.8rem;
        line-height: 1em;
    }

    .number {
        text-align: center;
        padding-top: 0.25rem;
        font-size: 0.8rem;
        line-height: 1em;
        opacity: 0.8;
    }
</style>